import { Outlet } from 'react-router'
import { AuthLayout } from '#app/components/catalyst/auth-layout.tsx'

export default function AuthLayoutRoute() {
	return (
		<AuthLayout>
			<Outlet />
		</AuthLayout>
	)
}
